import React from "react";
import "../styles/SuccessPage.css";

const SuccessPage = () => {
    return (
        <div className="success-container">
            <div className="success-card">
                <div className="success-icon">🎉</div>
                <h2 className="success-title">Reservation Submitted!</h2>
                <p className="success-message">
                    Thank you! Your reservation at <strong>Sol Cafe & Lounge</strong> has been submitted.
                </p>
                <p className="success-note">
                    If your reservation is for <strong>Thursday, Friday, or Saturday</strong>, please check your text messages for
                    <strong> e-transfer instructions</strong> to confirm your spot.
                </p>
                <p className="success-note">
                    If you don’t receive a message within a few minutes, please contact us.
                </p>
                <a href="/" className="success-button">
                    Return Home
                </a>
            </div>
        </div>
    );
};

export default SuccessPage;
